<template>
  <div class="flex flex-col my-10 md:my-20">
    <div class="flex flex-col items-center">
      <h1 class="text-xl md:text-3xl font-bold text-center lg:w-full mb-8">
        Hello {{ customerName }}
      </h1>
      <p class="text-sm md:text-base leading-loose text-center lg:w-full mb-12">
        Please click on the type of claim you want to make
      </p>
    </div>

    <div class="grid md:grid-cols-4">
      <Category
        v-for="(form, i) in categories"
        :key="i"
        :category="category"
        :title="form.title"
        :value="form.value"
        :info="form.description"
        @click="selectCategory(form.value)"
      />
    </div>

    <hr class="mt-10 mb-4 border-t border-gray-400 w-1/2" />

    <div>
      <MainButton
        id="continue"
        title="Continue"
        :disabled="!category"
        purple
        medium
        shadow
        @click="nextPage()"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Category from '@/components/Categories/Category.vue';

export default {
  name: 'Categories',
  components: {
    Category
  },
  computed: {
    ...mapState({
      categories: (state) => state.meta.categories,
      category: (state) => state.claim.category,
      customerName: (state) => state.customer.customer.firstName
    })
  },
  mounted() {
    const { commit, dispatch } = this.$store;

    commit('SET_PROGRESS', 'categories');

    dispatch('GET_BANKDETAILS_QUESTIONS');

    dispatch('GET_COUNTRIES');
    dispatch('GET_CURRENCIES');

    dispatch('CLEAR_DOCUMENTS');
    dispatch('CLEAR_COMPENSATIONS');
    /*if (getters.isDirty) {
      dispatch('CLEAR_DOCUMENTS');
      dispatch('CLEAR_COMPENSATIONS');
    }*/
  },
  methods: {
    nextPage() {
      this.$router.push('provide-information');
      this.scrollToTop();
    },
    selectCategory(category) {
      this.$store
        .dispatch('UPDATE_CLAIM', { category })
        .catch((e) => this.$store.commit('SET_ERROR', e));

      document
        .querySelector('#continue')
        .scrollIntoView({ behavior: 'smooth' });
    }
  }
};
</script>
